import { render, staticRenderFns } from "./NewProductColor.vue?vue&type=template&id=142a4656&functional=true&"
import script from "./NewProductColor.vue?vue&type=script&lang=js&"
export * from "./NewProductColor.vue?vue&type=script&lang=js&"
import style0 from "./NewProductColor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports